import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { fetchOperationPlans } from './operationsSlice'
import { OperationsTabBar } from './components/OperationsTabBar'
import { QueueHealthBadge } from './components/QueueHealthBadge'
import { PLAN_STATUS_COLORS } from './types/operations.types'
import {
  OpsPageWrapper,
  OpsCard,
  OpsCardHeader,
  OpsTable,
  OpsTableHead,
  OpsTableRow,
  OpsButton,
  Badge,
  ProgressBarWrapper,
  ProgressBarFill,
  opsColors,
} from './styled/Operations.styled'
import { NavBar } from 'components/NavBar/NavBar'

export const OperationPlanList: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const { plans, isLoading } = useSelector((state: RootState) => state.operations)

  useEffect(() => {
    dispatch(fetchOperationPlans({}))
  }, [dispatch])

  return (
    <>
      <NavBar />

      <OpsPageWrapper>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <h1 style={{ fontSize: '30px', fontWeight: 900, color: opsColors.textPrimary, margin: 0, fontFamily: 'DM Sans, sans-serif' }}>
            Operations Control
          </h1>
          <OpsButton onClick={() => navigate('/ops-control/plans/create')}>
            + Create Plan
          </OpsButton>
        </div>

        <OperationsTabBar />

        <OpsCard noPadding>
          <div style={{ padding: '1.25rem 1.25rem 0.5rem' }}>
            <OpsCardHeader>
              <h3>Operation Plans</h3>
            </OpsCardHeader>
          </div>
          <OpsTable>
            <OpsTableHead>
              <tr>
                <th>Plan Name</th>
                <th>Site</th>
                <th>Department</th>
                <th>Target</th>
                <th style={{ width: '120px' }}>Progress</th>
                <th>Est. Completion</th>
                <th>Queue Health</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </OpsTableHead>
            <tbody>
              {plans?.map((plan) => (
                <OpsTableRow key={plan.id} clickable onClick={() => navigate(`/ops-control/plans/${plan.id}`)}>
                  <td style={{ fontWeight: 700, color: opsColors.textPrimary }}>{plan.name}</td>
                  <td style={{ fontSize: '12px', color: opsColors.textFaded }}>{plan.siteName}</td>
                  <td style={{ fontSize: '12px', color: opsColors.textFaded }}>{plan.departmentName}</td>
                  <td style={{ fontSize: '14px' }}>{plan.targetValue} {plan.targetUnit}</td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <ProgressBarWrapper style={{ flex: 1 }}>
                        <ProgressBarFill percent={plan.progress} />
                      </ProgressBarWrapper>
                      <span style={{ fontSize: '12px', color: opsColors.textSecondary }}>{plan.progress}%</span>
                    </div>
                  </td>
                  <td style={{ fontSize: '12px', color: opsColors.textFaded }}>
                    {plan.estCompletion ? new Date(plan.estCompletion).toLocaleDateString() : '-'}
                  </td>
                  <td><QueueHealthBadge health={plan.queueHealth} /></td>
                  <td><Badge bg={PLAN_STATUS_COLORS[plan.status]}>{plan.status}</Badge></td>
                  <td onClick={(e) => e.stopPropagation()}>
                    {plan.status === 'Active' && (
                      <OpsButton variant="secondary" size="sm">Pause</OpsButton>
                    )}
                    {plan.status === 'Paused' && (
                      <OpsButton variant="success" size="sm">Resume</OpsButton>
                    )}
                    {plan.status === 'Draft' && (
                      <OpsButton size="sm">Activate</OpsButton>
                    )}
                  </td>
                </OpsTableRow>
              ))}
            </tbody>
          </OpsTable>
          {isLoading && <div style={{ padding: '2rem', textAlign: 'center', color: opsColors.textFaded }}>Loading...</div>}
        </OpsCard>
      </OpsPageWrapper>
    </>
  )
}
